/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function PhoneJuicyIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="phone-juicy"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M20.23 4.087C20.379 4.83 20.435 5.014 20.513 5.768C20.571 6.333 20.594 6.902 20.581 7.471C20.574 7.755 20.556 8.039 20.534 8.322C20.522 8.474 20.497 8.625 20.479 8.777L20.175 8.741C19.141 8.396 18.107 8.053 17.074 7.707C16.743 7.596 16.441 7.406 16.2 7.153C15.815 6.75 15.598 6.202 15.605 5.644C15.607 5.41 15.649 5.177 15.726 4.955C15.791 4.771 15.881 4.596 15.993 4.436C16.13 4.241 16.3 4.069 16.492 3.929C16.723 3.762 16.987 3.641 17.264 3.576C17.601 3.498 17.953 3.503 18.288 3.588C18.935 3.753 19.582 3.921 20.23 4.087Z" data-tinysvg-shape="path" stroke="none" fill={color} data-fill-tone="primary" />
          <path d="M8.777 20.479C8.625 20.497 8.474 20.522 8.322 20.534C8.039 20.556 7.755 20.574 7.471 20.581C6.902 20.594 6.333 20.571 5.768 20.513C5.014 20.435 4.83 20.379 4.088 20.23C3.921 19.582 3.753 18.935 3.588 18.288C3.503 17.953 3.498 17.601 3.576 17.264C3.641 16.987 3.762 16.723 3.929 16.492C4.069 16.3 4.241 16.13 4.436 15.993C4.596 15.881 4.771 15.791 4.955 15.726C5.177 15.649 5.41 15.607 5.644 15.605C6.202 15.598 6.75 15.815 7.153 16.2C7.406 16.441 7.596 16.743 7.707 17.074C8.053 18.107 8.396 19.141 8.741 20.175L8.777 20.479Z" data-tinysvg-shape="path" stroke="none" fill={color} data-fill-tone="primary" />
          <path d="M20.23 4.087A13.431 13.431 315 0 1 4.087 20.23" data-tinysvg-shape="arc" data-tinysvg-arc="7.154 7.154 13.431 13.431 31.804 148.196 315 three-point" stroke={color} fill="none" data-stroke-tone="primary" strokeWidth={scaledStrokeWidth(128.57)} data-tinysvg-stroke-width="128.57" />
          <path d="M20.23 4.088L18.288 3.588C17.094 3.282 15.888 4.039 15.646 5.248C15.434 6.31 16.046 7.364 17.074 7.707L20.175 8.741" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" strokeWidth={scaledStrokeWidth(128.57)} data-tinysvg-stroke-width="128.57" />
          <path d="M4.088 20.23L3.588 18.288C3.282 17.094 4.039 15.888 5.248 15.646C6.31 15.434 7.364 16.046 7.707 17.074L8.741 20.175" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" strokeWidth={scaledStrokeWidth(128.57)} data-tinysvg-stroke-width="128.57" />
    </svg>
  )
}
